export const Colors = {
    primary: "#184ABD",
    secondary: "#2e97ff",
    conqPrimary: "#D7BE69",
    black: "#13141A",
    white: "#FFFFFF",
    altBlack: "#303030",
};
